<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import { onMount } from "svelte";
import uiStore from "../utils/UIStore";
import InfoTooltip from "./InfoTooltip.svelte";

export let availableLLMs = [];
export let llmIsSelected = false;
export let selectedLLM;
export let dropdownIndex = 0;
export let relevantStore;
export let pageName = null;

export const buttonDisabled = false;

import { tick } from "svelte";

export { updateDropdownIndex };

let proOpen = false;

let uiTexts;
uiStore.textStore.subscribe((store) => {
	uiTexts = store.texts;
});

updateDropdownIndex();

relevantStore.subscribe((update) => {
	updateDropdownIndex();
});

onMount(() => {
	const name = `showOptions${pageName}`;
	proOpen = localStorage[name] === "true";
	document.getElementById("toggle").checked = proOpen;

	document
		.getElementById("toggle-container")
		.addEventListener("keydown", (event) => {
			if (event.key === "Enter") {
				toggleOptions();
				document.getElementById("toggle").checked = proOpen;
			}
		});
});

//set dropdownindex to selected LLM if LLM has been selected, otherwise index=0
//we use an index as a the value for the dropdown because the options of the dropdown are beeing updated every 30sec.
async function updateDropdownIndex() {
	await tick();
	if (selectedLLM !== undefined) {
		dropdownIndex = availableLLMs.findIndex(
			(llm) => llm.name === selectedLLM.name,
		);
		if (dropdownIndex === -1) {
			dropdownIndex = 0;
		}
	}
}

function toggleOptions() {
	proOpen = !proOpen;
	const name = `showOptions${pageName}`;
	localStorage[name] = proOpen;
}
</script>

<div class="container">
    {#if proOpen}
        <div class="select-container">
            <div
                style="display:flex;justify-content: space-between;align-items: center;"
            >
                <label style="text-align:left;" for="select-llm"
                    >{uiTexts.modelSelection.label}</label
                >
                <InfoTooltip
                    infoText="{uiTexts.modelSelection.tooltipModel}"
                />
            </div>

            <select
                style="margin:0px;"
                bind:value={dropdownIndex}
                id="select-llm"
                name="select-llm"
                on:change={() => {
                    llmIsSelected = true;
                    selectedLLM = availableLLMs[dropdownIndex];
                }}
            >
                {#each availableLLMs as model, i}
                    <option value={i}>
                        {model.label}
                        {#if model.is_remote}
                            &nbsp;&#9729;
                        {/if}
                    </option>
                {/each}
            </select>
        </div>
    {/if}
    <div style="display:flex; flex-direction: column; align-items:start;">
        <div style="display:flex; flex-direction:row;align-items: center;">
            <span style="font-size:1rem;">{uiTexts.modelSelection.options}</span>
            <InfoTooltip
                yOffest="-92px"
                infoText="{uiTexts.modelSelection.tooltipOptions}"
            />
        </div>
        <label
            class="switch"
            role="switch"
            aria-checked={proOpen}
            tabindex="0"
            aria-label="{uiTexts.modelSelection.ariaOptions}"
            id="toggle-container"
        >
            <input
                id="toggle"
                type="checkbox"
                tabindex="-1"
                value={proOpen}
                on:change={() => {
                    toggleOptions();
                }}
            />
            <span class="slider"></span>
        </label>
    </div>
</div>

<style>
    .container {
        display: flex;
        align-items: end;
        gap: 20px;
    }

    .select-container {
        display: flex;
        flex-direction: column;
        min-width: 300px;
    }

    select,
    select:active {
        width: 100%;
        background-color: white;
        color: black;
        border-radius: 0px !important;
        border: 2px solid #000 !important;
    }

    select:focus,
    select:focus-visible {
        outline: 2px solid #000;
        outline-offset: 1px;
    }

    /* The switch - the box around the slider */
    .switch {
        position: relative;
        display: inline-block;
        width: 70px;
        height: 38px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .switch:focus-visible,
    .switch:focus {
        outline: 2px solid #000;
        outline-offset: 1px;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
        border: 2px solid var(--sec-color);
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 30px;
        width: 30px;
        left: 34px;
        bottom: 2px;
        background-color: var(--sec-color);
        -webkit-transition: 0.4s;
        transition: 0.4s;
    }

    input:checked + .slider {
        background-color: white;
        opacity: 1;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px black;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(-32px);
        -ms-transform: translateX(-32px);
        transform: translateX(-32px);
    }
</style>
